import { Type, type Static } from '@sinclair/typebox';
import { FIELD_LIMITS } from '../constants.js';
import { RowVersionField, SoftDeleteFields, TimestampFields, UuidSchema } from './common.js';

const NullableText = (maxLength: number) =>
  Type.Union([Type.String({ maxLength }), Type.Null()]);

export const SupplierCategorySchema = Type.Object({
  id: UuidSchema,
  parentCategoryId: Type.Union([UuidSchema, Type.Null()]),
  name: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX }),
  notes: NullableText(FIELD_LIMITS.NOTES_MAX),
  isActive: Type.Boolean(),
  ...TimestampFields,
  ...SoftDeleteFields,
  ...RowVersionField,
});
export type SupplierCategory = Static<typeof SupplierCategorySchema>;

export const SupplierCategoryCreateSchema = Type.Object({
  parentCategoryId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  name: Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX }),
  notes: Type.Optional(Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX })),
});
export type SupplierCategoryCreate = Static<typeof SupplierCategoryCreateSchema>;

export const SupplierCategoryUpdateSchema = Type.Object({
  parentCategoryId: Type.Optional(Type.Union([UuidSchema, Type.Null()])),
  name: Type.Optional(Type.String({ minLength: 1, maxLength: FIELD_LIMITS.NAME_MAX })),
  notes: Type.Optional(NullableText(FIELD_LIMITS.NOTES_MAX)),
  isActive: Type.Optional(Type.Boolean()),
  rowVersion: Type.Integer({ minimum: 0 }),
});
export type SupplierCategoryUpdate = Static<typeof SupplierCategoryUpdateSchema>;
